import { endpoint } from './default';

const getHuntByCwId = (cwId) => endpoint.get(`/cwhunt/cw_id/${cwId}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getAllCwHunt = () => endpoint.get('/cwhunt/all', {
  params: {
    tag: 'CodingWizard',
  },
});

const createCwHunt = (data) => endpoint.post('/cwhunt', data, {
  params: {
    tag: 'CodingWizard',
  },
});

const updateCwHunt = (id, data) => endpoint.put(`/cwhunt/${id}`, data, {
  params: {
    tag: 'CodingWizard',
  },
});

const deleteCwHunt = (id) => endpoint.delete(`/cwhunt/delete/${id}`, null, {
  params: {
    tag: 'CodingWizard',
  },
});

const getHuntByClassAndProblem = (classId, pid) => endpoint.get(`/cwhunt/class_id/${classId}/problem_id/${pid}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getHuntByClassAndWeek = (classId, wid) => endpoint.get(`/cwhunt/class_id/${classId}/week_id/${wid}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getHuntByIdInOneClass = (classId, cwId) => endpoint.get(`/cwhunt/class_id/${classId}/cw_id/${cwId}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getHuntRate = (classId, cwId) => endpoint.get(`/cwhunt/class_id/${classId}/cw_id/${cwId}/ac_rate`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getAllHuntRate = (classId) => endpoint.get(`/cwhunt/class_id/${classId}/ac_rate`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getAllHuntByClass = (classId) => endpoint.get(`/cwhunt/class_id/${classId}/all`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getAllHuntByClassAndDate = (classId, date) => endpoint.get(`/cwhunt/date/${date}/class_id/${classId}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getAllHuntByDate = (date) => endpoint.get(`/cwhunt/date/${date}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getRankList = () => endpoint.get('/cwhunt/ranklist', {
  params: {
    tag: 'CodingWizard',
  },
});

const getRankListDiff = () => endpoint.get('/cwhunt/ranklist/recent_ac_diff', {
  params: {
    tag: 'CodingWizard',
  },
});

const getCwhuntByClassAndStatus = (classId, status) => endpoint.get(`/cwhunt/class_id/${classId}/all/${status}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getCwhuntByClassAndGrade = (classId, grade) => endpoint.get(`/cwhunt/grade/${grade}/class_id/${classId}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getCwhuntGrade = (grade) => endpoint.get(`/cwhunt/all/grade/${grade}`, {
  params: {
    tag: 'CodingWizard',
  },
});

export {
  getHuntByCwId,
  getAllCwHunt,
  createCwHunt,
  updateCwHunt,
  deleteCwHunt,
  getHuntByClassAndProblem,
  getHuntByClassAndWeek,
  getHuntRate,
  getAllHuntRate,
  getHuntByIdInOneClass,
  getRankList,
  getRankListDiff,
  getAllHuntByClass,
  getAllHuntByClassAndDate,
  getAllHuntByDate,
  getCwhuntByClassAndStatus,
  getCwhuntByClassAndGrade,
  getCwhuntGrade,
};
